import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { BookingService } from '../service/booking.service';
import { VivawalletPaymentOrderInfo } from '../vivawallet-payment-order-info';

@Component({
  selector: 'app-vivawallet-payment-orders',
  templateUrl: './vivawallet-payment-orders.component.html',
  styleUrls: ['./vivawallet-payment-orders.component.css']
})
export class VivawalletPaymentOrdersComponent implements OnInit {

  loading = true;
  paymentOrders: VivawalletPaymentOrderInfo[] = [];

  constructor(
    private httpService: HttpService,
    private bookingService: BookingService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.paymentOrders = [];
    this.httpService.getVivawalletPaymentOrders(this.bookingService.booking.id!).subscribe(res => {
      this.paymentOrders = res;
      this.loading = false;
    }, error => {
      console.error(error);
      this.loading = false;
    });
  }

}
